export default "__VITE_ASSET__8wty5UGg__"